const cronPurchaseUser = [
  {
    group: 'Compradores',
    columns: [
      {
        name: 'Id',
        id: 'id-id',
        show: false
      },
      {
        name: 'Email',
        id: 'user-nome',
        show: true
      },
      // {
      //   name: 'Mundo',
      //   id: 'user-mundo',
      //   show: true
      // },

      {
        name: 'Fornecedor',
        id: 'user-fornecedor',
        show: true
      },
      {
        name: 'Categoria Compacta',
        id: 'user-categoria',
        show: true
      }
    ]
  }
]
export default cronPurchaseUser
